import { RouterProvider } from 'react-router-dom';
import { chatroomListRouter, adminRouter } from './router';
import LIFFUserProvider from './LIFFUserProvider';
import ReactModal from 'react-modal';
import { LoadingContext } from './contexts/LoadingContext';
import { useState } from 'react';
import Spinner from './share/Spinner';

export default function App() {
  ReactModal.setAppElement('#root');
  const fragment = window.location.hash;
  const isAdminPage = /^#\/?(admin)\/?/.test(fragment);

  const [isLoading, setIsLoading] = useState(false);

  if (isAdminPage) {
    return <RouterProvider router={adminRouter} />;
  }

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      <LIFFUserProvider>
        <RouterProvider router={chatroomListRouter} />
      </LIFFUserProvider>

      <ReactModal
        isOpen={isLoading}
        overlayClassName="z-[1001] fixed bg-white/[.4] inset-0 backdrop-blur-sm"
        className="flex h-full w-full justify-center items-center px-5"
      >
        <Spinner />
      </ReactModal>
    </LoadingContext.Provider>
  );
}
